<script>
import Input from "@/components/c-input";
import Select from "@/components/c-select";

/* eslint-disable no-console */
/**
 * Item List component
 */
export default {
  components: {
    Input,
    Select
  },
  data() {
    return {
      valueId: 0,
      valueQuantity: 1,
      valuePrice: 0,
      valueAmount: 0,
      valueCheck: false,
      valueName: '',
      valueNameEn: '',
      valueMonthBilling: 0,
      valueServiceFor: 1,

      monthBillingData: {data: [
        {id: 1, name: "មករា"}, {id: 2, name: "កុម្ភៈ"}, {id: 3, name: "មីនា"}, 
        {id: 4, name: "មេសា"}, {id: 5, name: "ឧសភា"}, {id: 6, name: "មិថុនា"}, 
        {id: 7, name: "កក្កដា"}, {id: 8, name: "សីហា"}, {id: 9, name: "កញ្ញា"}, 
        {id: 10, name: "តុលា"}, {id: 11, name: "វិច្ឆិកា"}, {id: 12, name: "ធ្នូ"}
      ]},

      serviceFor: {data: [
        {id: 1, name: "ម្ចាស់បន្ទប់"}, {id: 2, name: "អ្នកជួល"} 
      ]},

    };
  },
  watch: {

    item: {
      immediate: true, 
      handler (val) {
        this.valueId = val.id;
        this.valueQuantity = val.quantity ? val.quantity : 1;
        this.valuePrice = val.price;
        this.valueAmount = val.price;
        this.valueCheck = val.check;
        this.valueName = val.name;
        this.valueNameEn = val.name_en;
        this.valueMonthBilling = val.monthBilling;
        this.valueServiceFor = val.service_for==2 ? 2 : 1;
        // console.log(val);
      }
    },
    lookServiceFor: {
      immediate: true, 
      handler (val) {
        this.isServiceFor = val
      }
    },
  },

  mounted() {

  },
  methods: {
    
    getItem: function() {
      return {
        id: this.valueId,
        quantity: this.valueQuantity,
        price: this.valuePrice,
        amount: this.valueAmount,
        check: this.valueCheck,
        name: this.valueName,
        name_en: this.valueNameEn,
        monthBilling: this.valueMonthBilling ? this.valueMonthBilling : 0,
        service_for: this.valueServiceFor,
        old_record: 0,
        new_record: 0,
      }
    },

    formatCurrency(value, sign = '', decimal = '.00') {
      return  sign.length > 1 ? sign + this.$options.filters.numFormat(value, `0,0${decimal}`) : this.$options.filters.numFormat(value, `${sign}0,0${decimal}`);
    },

    changedValue: function(event) {
      
      this.valueAmount =  this.valueQuantity * this.valuePrice ;
      // console.log(this.valueQuantity, this.valuePrice)
      this.$emit('changed', {accountId: this.valueId, price: event, index: this.index});
    },

    checkedValue: function(event) {
      this.valueCheck = event.target.checked;
      this.valueAmount = this.valueCheck == true ? this.valueQuantity * this.valuePrice : 0;
    },


  },
  props: {
    item: null,
    index: {
      type: Number,
      default: 0
    },
    billingDateSelectable: {
      type: Boolean,
      default: false
    },
    lookServiceFor:{
      type: Boolean,
      default: false
    }
  },
};
</script>
<template>

  <div class="row border-top pt-3">
    <div class="col-1">
      <input
          class="form-check-input"
          type="checkbox"
          id="exclude"
          v-model="valueCheck"
          :checked="valueCheck"
          @input="checkedValue"
        />
    </div>
    <div class="col" v-if="this.lookServiceFor">
      <Select 
        :id="`servicefor_${index}`"
        :text="'name'"
        :disabled="this.valueCheck ? false : true"
        :list="serviceFor"
        v-model="valueServiceFor"
      /> 
     
    </div>
    <div class="col-sm-3">
      <span>{{valueName}} / </span>
      <span>{{valueNameEn}}</span>
    </div>
    <div class="col-sm-2">
       <Select 
        :id="`month_${index}`"
        :text="'name'"
        :disabled="this.billingDateSelectable ? false : true"
        :list="monthBillingData"
        v-model="valueMonthBilling"
      /> 
    </div>
    <div class="col-sm">
      <Input 
        v-on:input="changedValue"
        :type="'number'"
        :id="`quantity_${index}`"
        v-model="valueQuantity"
        />
    </div>
    <div class="col-sm">
      <Input 
        v-on:input="changedValue"
        :type="'number'"
        :id="`price_${index}`"
        v-model="valuePrice"
        />
    </div>
    <div class="col-sm">
      <Input 
        :type="'number'"
        :disabled="true"
        :id="`amount_${index}`"
        v-model="valueAmount"
        />
    </div>
  </div>
</template>